import React from 'react';
import { Imposter } from '@hub/imposter';
import { Cover } from '@hub/cover';
import { useIsRouteChanging } from '../../next/router';
import { jsx as _jsx } from "react/jsx-runtime";
const RouteChangeIndicator = function RouteChangeIndicator(_ref) {
  let {
    fallback: Fallback,
    children
  } = _ref;
  const isRouteChanging = useIsRouteChanging();
  return /*#__PURE__*/_jsx(Imposter, {
    impose: isRouteChanging ? /*#__PURE__*/_jsx(Cover, {
      sx: {
        zIndex: 'popover'
      },
      backgroundColor: "white",
      "data-id": "route-change-indicator_index_RouteChangeIndicator_Cover",
      children: /*#__PURE__*/_jsx(Fallback, {
        "data-id": "route-change-indicator_index_RouteChangeIndicator_Cover_Fallback"
      })
    }) : undefined,
    sx: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    "data-id": "route-change-indicator_index_RouteChangeIndicator_Imposter",
    children: children
  });
};
export default RouteChangeIndicator;